import React from 'react'

const Design = () => {
  return (
    <div className=' mt-[10%] md:mt-[4%]'>Design</div>
  )
}

export default Design